import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';

const ComponentStyled = styled(FormControlLabel)`
  .MuiButtonBase-root {
    margin-right: 11px;
  }
  &,
  .MuiCheckbox-root {
    color: ${({ theme }) => theme.colors.white};
  }
`;

const ContainerNoLabel = styled(Grid)`
  &.MuiGrid-container {
    color: ${({ theme }) => theme.colors.white};
    margin-left: -11px;
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
  }
  .MuiButtonBase-root {
    margin-right: 11px;
  }
  .MuiCheckbox-root {
    color: ${({ theme }) => theme.colors.white};
  }
`;

const Component = ({
  label,
  noLabelCheck,
  ariaLabel,
  containerProps,
  checkboxProps,
  ...props
}) => {
  const inputProps = {
    role: 'checkbox',
    'aria-label': ariaLabel,
  };

  return noLabelCheck ? (
    <ContainerNoLabel container {...containerProps}>
      <Grid item>
        <Checkbox inputProps={inputProps} {...props} {...checkboxProps} />
      </Grid>
      <Grid item>
        <Typography>{label}</Typography>
      </Grid>
    </ContainerNoLabel>
  ) : (
    <ComponentStyled
      {...containerProps}
      control={
        // https://material-ui.com/api/checkbox/
        <Checkbox inputProps={inputProps} {...props} {...checkboxProps} />
      }
      label={label}
    />
  );
};

Component.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  noLabelCheck: PropTypes.bool,
  ariaLabel: PropTypes.string,
  containerProps: PropTypes.object,
  checkboxProps: PropTypes.object,
};

export default Component;
